module.exports = __webpack_public_path__ + "static/media/2024-08-03-01.e24bbf07.png";